import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { API_BASE_URL } from '../../../../../config';
const FirstRefinance = () => {
  const [bankList, setBankList] = useState([]);
  const [formData, setFormData] = useState({
    UPAS_bank_name: '',
    UPAS_maturity_date: '',
    PI_document: null,
    LC_document: null,
    Acceptance_copy: null,
  });
  const [isFormVisible, setIsFormVisible] = useState(true);
  const navigate = useNavigate();

  const handleInputChange = e => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id]: value,
    });
  };

  // const handleFileChange = e => {
  //   setFormData({
  //     ...formData,
  //     PI_document: e.target.files[0], // Store the selected file in formData
  //     LC_document: e.target.files[0],
  //     Acceptance_copy: e.target.files[0],
  //   });
  // };

     const handleFileChange = (e, documentType) => {
       setFormData({
         ...formData,
         [documentType]: e.target.files[0], // Update only the specified document field
       });
     };

  const handleCloseApplyLoan = () => {
    setIsFormVisible(false);
    navigate('/NewLoanApplication');
  };

  // get all issue bank api
  useEffect(() => {
    const fetchBankList = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/account/bank-list/`,
          // 'https://finwise-backend.vercel.app/account/bank-list/',
          // 'https://finwiseback.finwise.com.bd/account/bank-list/',
          // 'http://127.0.0.1:8000/account/bank-list/',
          {
            headers: {
              Cookie:
                'csrftoken=YmXTCIwY0VzFyPEcOP15TL1stJiuNrZF; sessionid=l2509fh2uv9ulyzd6412afq0ufd2elpr',
            },
            withCredentials: true,
          }
        );

        // Assuming the response has a list of banks
        setBankList(response.data);
        // console.log(response);
      } catch (error) {
        console.error('Error fetching the bank list:', error);
      }
    };

    fetchBankList();
  }, []);

  const handleSubmit = async e => {
    e.preventDefault();

    const submissionData = new FormData();
    submissionData.append('UPAS_bank_name', formData.UPAS_bank_name);
    submissionData.append('UPAS_maturity_date', formData.UPAS_maturity_date);

    // if (formData.PI_document) {
    //   submissionData.append(
    //     'PI_document',
    //     formData.PI_document,
    //     formData.PI_document.name
    //   );
    // }
    if (formData.PI_document) {
      submissionData.append(
        'PI_document',
       null
      );
    }
    if (formData.LC_document) {
      submissionData.append(
        'LC_document',
       null
      );
    }
    // if (formData.LC_document) {
    //   submissionData.append(
    //     'LC_document',
    //     formData.LC_document,
    //     formData.LC_document.name
    //   );
    // }
    if (formData.Acceptance_copy) {
      submissionData.append(
        'Acceptance_copy',
       null
      );
    }
    // if (formData.Acceptance_copy) {
    //   submissionData.append(
    //     'Acceptance_copy',
    //     formData.Acceptance_copy,
    //     formData.Acceptance_copy.name
    //   );
    // }
    // Log the formData to verify the data being sent
    console.log('submissionData before submit:', submissionData);

    try {
      const response = await axios.post(
        `${API_BASE_URL}/account/first-refinance-loan/`,
        // 'https://finwise-backend.vercel.app/account/first-refinance-loan/',
        // 'https://finwiseback.finwise.com.bd/account/first-refinance-loan/',
        // 'http://127.0.0.1:8000/account/first-refinance-loan/',
        submissionData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Cookie:
              'csrftoken=YmXTCIwY0VzFyPEcOP15TL1stJiuNrZF; sessionid=l2509fh2uv9ulyzd6412afq0ufd2elpr',
          },
          withCredentials: true, // Include credentials if necessary
        }
      );

      // console.log('Loan application response:', response.data);

      Swal.fire({
        title: 'Success!',
        text: 'First Refinance application success.',
        customClass: {
          popup: 'w-72 h-auto p-3',
          title: 'text-lg',
          content: 'text-xs',
          confirmButton: 'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
        },
      });
      navigate('/dashboard');
    }catch (error) {
      if (error.response) {
        Swal.fire({
          title: 'Error!',
          text: error.response.data?.[0] || 'Please provide valid information.',
          customClass: {
            popup: 'w-72 h-auto p-3',
            title: 'text-lg',
            content: 'text-xs',
            confirmButton:
              'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
          },
        });
        console.error('Server response error:', error.response.data);
      } else {
        console.error('Error submitting loan application:', error);
      }
    }
  };

  return (
    <>
      {isFormVisible && (
        <div className="md:px-10 px-2 md:py-10 py-6 ">
          {/* title header */}
          <div className="bg-headerBtn md:w-full p-2  md:pl-8 pl-4 text-left rounded-t-lg ">
            <div className="flex justify-between">
              <div>
                <h2 className="md:text-2xl text-lg text-white font-bold md:mb-2">
                  First Refinance Application
                </h2>
                <p className="md:mb-2 text-xs md:text-sm text-white">
                  Apply for your initial loan refinancing and manage your
                  financial commitments with ease.
                </p>
              </div>

              {/* Close button */}
              {/* <button
                onClick={handleCloseApplyLoan}
                className="md:mr-4 mr-3 -mt-6 text-white text-2xl font-bold hover:text-btnHover"
              >
                &times;
              </button> */}
            </div>
          </div>

          {/* form fields */}
          <div className="bg-AboutUsBg md:text-sm text-xs flex flex-col items-center md:py-10 py-4 px-4 md:px-0 xl:h-screen">
            <form
              onSubmit={handleSubmit}
              action=""
              className="w-full max-w-4xl"
            >
              {/* All form fields start from here */}
              <div className="md:space-y-2 space-y-2">
                {/* UPAS Bank Name * */}
                <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24 gap-1 ">
                  <div>
                    <label
                      htmlFor="UPAS_bank_name"
                      className="block font-medium text-gray-700"
                    >
                      UPAS Bank Name <span className="text-red-600">*</span>
                    </label>
                  </div>

                  <div className="flex md:gap-2">
                    <div>
                      <span className="text-3xl hidden md:block ml-3">:</span>
                    </div>

                    <div className="">
                      <select
                        id="UPAS_bank_name"
                        value={formData.UPAS_bank_name}
                        onChange={handleInputChange}
                        className="md:w-96 w-64 p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50"
                        required
                      >
                        <option value="">Select Bank</option>
                        {bankList.map((bank, index) => (
                          <option key={index} value={bank[0.0]}>
                            {bank[0.0]}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                {/* UPAS Maturity Date * */}
                <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24 gap-1">
                  <div>
                    <label
                      htmlFor="UPAS_maturity_date"
                      className="block font-medium text-gray-700"
                    >
                      UPAS Maturity Date
                      <span className="text-red-600">*</span>
                    </label>
                  </div>

                  <div className="flex md:gap-2">
                    <div>
                      <span className="hidden md:block text-3xl ml-1">:</span>
                    </div>

                    <div className="">
                      <input
                        type="date"
                        id="UPAS_maturity_date"
                        value={formData.UPAS_maturity_date}
                        onChange={handleInputChange}
                        className="md:w-96 w-64 p-2 border border-gray-300 rounded-md"
                        required
                      />
                    </div>
                  </div>
                </div>
                {/* Documents Upload : */}
                <div className="pt-10 pb-4">
                  <h1 className="heading text-xl ">Documents Upload :</h1>
                </div>
                <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24 gap-1">
                  <div>
                    <label
                      htmlFor="PI_document"
                      className="block font-medium text-gray-700"
                    >
                      PI Copy <span className="text-red-600">*</span>
                    </label>
                  </div>

                  <div className="flex md:gap-2">
                    <div>
                      <span className="hidden md:block text-3xl ml-20">:</span>
                    </div>

                    <div className="">
                      <input
                        type="file"
                        id="PI_document"
                        name="logo"
                        // onChange={handleFileChange}
                        // onChange={e => handleFileChange(e, 'PI_document')}
                        className="md:w-96 w-64 p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50 bg-white"
                        required
                      />
                      <p className="hidden">
                        {formData.PI_document
                          ? formData.PI_document.name
                          : 'No file selected'}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24 gap-1">
                  <div>
                    <label
                      htmlFor="LC_document"
                      className="block font-medium text-gray-700"
                    >
                      LC Copy<span className="text-red-600">*</span>
                    </label>
                  </div>

                  <div className="flex md:gap-2">
                    <div>
                      <span className="hidden md:block text-3xl ml-20">:</span>
                    </div>

                    <div className="">
                      <input
                        type="file"
                        id="LC_document"
                        name="logo"
                        // onChange={handleFileChange}
                        // onChange={e => handleFileChange(e, 'LC_document')}
                        className="md:w-96 w-64 p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50 bg-white"
                        required
                      />
                      <p className="hidden">
                        {formData.LC_document
                          ? formData.LC_document.name
                          : 'No file selected'}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24 gap-1">
                  <div>
                    <label
                      htmlFor="Acceptance_copy"
                      className="block font-medium text-gray-700"
                    >
                      Acceptance Copy<span className="text-red-600">*</span>
                    </label>
                  </div>

                  <div className="flex md:gap-2">
                    <div>
                      <span className="hidden md:block text-3xl ml-3">:</span>
                    </div>

                    <div className="">
                      <input
                        type="file"
                        name="logo"
                        id="Acceptance_copy"
                        // onChange={handleFileChange}
                        // onChange={e => handleFileChange(e, 'Acceptance_copy')}
                        className="md:w-96 w-64 p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50 bg-white"
                        required
                      />
                      <p className="hidden">
                        {formData.Acceptance_copy
                          ? formData.Acceptance_copy.name
                          : 'No file selected'}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* All form fields end */}

              {/* Apply and cancel Buttons  */}
              <div className="flex md:w-full w-2/3 justify-center space-x-4 mt-6 ">
                <button
                  // onClick={handleSubmit}
                  type="submit"
                  className="bg-headerBtn text-white md:py-2 py-1 md:px-6 px-2 text-xs md:text-sm rounded-lg hover:bg-btnHover"
                >
                  Apply Now
                </button>
                <button
                  onClick={handleCloseApplyLoan}
                  type="button"
                  className="border-headerBtn border-2 text-headerBtn text-xs md:text-sm md:py-2 py-1 md:px-6 px-2 rounded-lg hover:bg-btnHover hover:text-white"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default FirstRefinance;
